module.exports = __webpack_public_path__ + "static/assets/16eb1b301e20538202ea78b5f3f9959b.png";